import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text, TextInput } from '@mantine/core';
import {
    Alert, Button, ButtonGroup, ButtonToolbar, Col, Form, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import {
    CheckboxField,
    ControlPageBlock,
    DateTimeField,
    ImageLeadField,
    InputField,
    RatingSelectorField,
    SearchSelectorField,
    TextAreaEditorField,
    TextAreaField,
} from '../blocks/edit_blocks';
import DownloadButtonsBlock from '../blocks/game_download_buttons_block';
import GalleryBlock from '../blocks/game_gallery_block';
import GameReleaseBlock from '../blocks/GameReleaseBlock';
import RequirementsBlock from '../blocks/requirements';
import SearchDragList from '../blocks/search_drag_list';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import Dispatcher from '../common/dispatcher';
import MapGame from '../components/MappedGames/MapGame';
import MappedGames from '../components/MappedGames/MappedGames';
import RuStorePackage from '../components/RuStorePackage';
import { API_DOMAIN, PROJECT_PREFIX } from '../const';
import { buildGameURL } from '../tools/build_urls';
import clearCache from '../tools/clearCache';
import {
    formatDateTime, formatDateTimeForDRF, getMoscowTime, Text2Slug,
} from '../tools/converters';
import { getBase64 } from '../tools/files';

export default class GameEditScreen extends React.Component {
    constructor(props) {
        super(props);
        const current_date = new Date(getMoscowTime()).toISOString();
        this.state = {
            dist_types: [
                { value: 1, label: 'Розничная продажа' },
                { value: 2, label: 'Подписка' },
                { value: 3, label: 'Бесплатная' },
                { value: 4, label: 'Условно-бесплатная' },
                { value: 5, label: 'Цифровая доставка' },
            ],
            facts: {},
            fact_text: '',
            data: {
                gallery: '',
                slug: '',
                releases: [],
                urls: [],
                date_published: formatDateTimeForDRF(current_date),
                dist_model: '',
                system_requirements: null,
                icon: '',
            },
            loading: true,
            not_valid: {},
        };
        this.autoSave = this.autoSave.bind(this);
        this.onChange = (editorState) => this.setState({ editorState });
        this.titleChange = this.titleChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleData = this.handleData.bind(this);
        this.refresh = this.refresh.bind(this);

        this.getTheFacts = this.getTheFacts.bind(this);
        this.addTheFact = this.addTheFact.bind(this);
        this.factDragEndHandle = this.factDragEndHandle.bind(this);
        this.updateTheFacts = this.updateTheFacts.bind(this);
        this.removeTheFactHandler = this.removeTheFactHandler.bind(this);

        this.dtHandleChange = this.dtHandleChange.bind(this);
        this.handleGalleryChange = this.handleGalleryChange.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        this.getSelectedDistr = this.getSelectedDistr.bind(this);
        this.distSelected = this.distSelected.bind(this);

        if (props.match.params.topicId) {
            this.state.API_ENDPOINT = `games/${props.match.params.topicId}/`;
        } else {
            this.state.API_ENDPOINT = 'games/';
        }
    }

    autoSave() {
        this.sendData({ target: { id: 'autosave' }, currentTarget: { id: 'autosave' } });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        this.validate();

        const save_type = event.currentTarget.id;

        let request_method = 'PUT';

        if (!this.props.match.params.topicId) {
            request_method = 'POST';
        }

        const callback = (data) => {
            const url = buildGameURL(this.state.data.slug);

            clearCache(url);

            if (save_type === 'save_button') {
                return this.goToPreviousPage(data);
            }

            if (!this.props.match.params.topicId) {
                return this.goToNewPage(data);
            }

            this.handleData(data);
        };

        Fetcher(this.state.API_ENDPOINT, request_method, callback, this.state.data);
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `games/${newData.id}/` });
        this.props.history.push(`${PROJECT_PREFIX}/games/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/games/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    addTheFact() {
        Fetcher(`${this.state.API_ENDPOINT}facts/`, 'POST', this.getTheFacts, { fact_text: this.state.fact_text });
    }

    getTheFacts(data) {
        this.setState({ facts: data });
    }

    updateTheFacts(event) {
        this.setState({ [[event.currentTarget.id]]: event.currentTarget.value });
    }

    factDragEndHandle(event) {
        const { draggableId } = event;
        const item_id = parseInt(draggableId.split('_')[0]);
        const src_priority = parseInt(draggableId.split('_')[1]);
        const src_pos = event.source.index;
        const dst_pos = event.destination.index;
        let new_priority = 0;

        if ((dst_pos - src_pos) > 0) {
            new_priority = src_priority - (dst_pos - src_pos);
        } else {
            new_priority = src_priority + (src_pos - dst_pos);
        }

        const uri = `${this.state.API_ENDPOINT.replace('?', '')}facts/${item_id}/`;
        Fetcher(
            uri,
            'PUT',
            this.handleData,
            ({
                id: item_id, priority: new_priority,
            }),
        );
    }

    removeTheFactHandler(event) {
        const item_id = event.currentTarget.id;
        const uri = `${this.state.API_ENDPOINT.replace('?', '')}facts/${item_id}/`;
        Fetcher(uri, 'DELETE', this.handleData);
    }

    componentDidMount() {
        const current_date = new Date(getMoscowTime()).toISOString();

        if (this.props.match.params.topicId) {
            const timer = setInterval(this.autoSave, 300000);
            this.setState({ timer });
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
            Fetcher(`${this.state.API_ENDPOINT}facts/`, 'GET', this.getTheFacts);
        } else {
            this.setState({
                loading: false,
                data: {
                    slug: '',
                    date_published: formatDateTimeForDRF(current_date),
                    dist_model: '',
                    icon: '',
                },
            });
        }
    }

    distSelected(event) {
        const result = [];

        for (let i = 0; i < event.length; i++) {
            result.push(event[i].label);
        }

        this.setState({
            data: {
                ...this.state.data,
                dist_model: result.join(','),
            },
        });
    }

    handleChange(event) {
        let state = event.currentTarget.value;

        if (event.currentTarget.type === 'checkbox') {
            state = event.currentTarget.checked;
        }

        if (event.currentTarget.type === 'file') {
            const file = event.currentTarget.files[0];
            // let file_size = file.size/1024/1024;
            const file_type = file.type;

            if (file_type !== 'image/jpeg' && file_type !== 'image/png') {
                return;
                // TODO: окно с сообщением, что формат файла не подходит
            }

            const event_target_id = event.currentTarget.id;
            getBase64(file, (result) => {
                const new_state = this.state;
                new_state.data[event_target_id] = result;
                this.setState(new_state);
            });

            return;
        }

        const data = JSON.parse(JSON.stringify(this.state.data));
        data[event.currentTarget.id] = state;

        this.setState({ data });
    }

    handleGalleryChange(gallery_obj) {
        // gallery_obj = {id, date_added, entity_alias, entity_id}
        const new_state = this.state;
        new_state.data.gallery = gallery_obj;
        this.setState(new_state);
    }

    dtHandleChange(date) {
        const new_state = this.state;
        new_state.data.date_published = date;
        this.setState(new_state);
    }

    handleReleaseChange = (newReleases) => {
        this.setState({
            data: {
                ...this.state.data,
                releases: newReleases,
            },
        });
    };

    handleUrlsChange = (newUrl) => {
        this.setState({
            data: {
                ...this.state.data,
                urls: newUrl,
            },
        });
    };

    titleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;

        if (!this.props.match.params.topicId) {
            new_state.data.slug = Text2Slug(state);
        }

        this.setState(new_state);
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['name', 'slug', 'picture', 'picture2', 'site', 'descr', 'site_url', 'name_alt', 'name_synonym'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    facts_columns = [
        {
            Header: '',
            sortable: false,
            accessor: 'priority',
            maxWidth: 70,
            Cell: (row) => (
                <ButtonToolbar>
                    <ButtonGroup>
                        <Button
                            size="sm"
                            variant="link"
                            id={row.row.id}
                            data-value={row.value}
                            onClick={this.moveItemUp}
                        >
                            <FontAwesomeIcon icon="arrow-up" id={row.row.id} data-value={row.value} />
                        </Button>
                        <Button
                            size="sm"
                            variant="link"
                            id={row.row.id}
                            data-value={row.value}
                            onClick={this.moveItemDown}
                        >
                            <FontAwesomeIcon icon="arrow-down" id={row.row.id} data-value={row.value} />
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            ),

        }, {
            Header: 'Текст',
            accessor: 'text',
        }, {
            Header: '',
            accessor: 'id',
            maxWidth: 40,
            Cell: (row) => (
                <Button size="sm" variant="link" id={row.value} onClick={this.removeTheFactHandler}>
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>
            ),
        }];

    game_facts() {
        return (
            <>
                <Col md={8}>
                    <TableScreenWithoutUpdate
                        draggable
                        draggableKey="priority"
                        handleDragEnd={this.factDragEndHandle}
                        columns={this.facts_columns}
                        endpoint={`${this.state.API_ENDPOINT}facts/`}
                        disableAutoRefresh
                    />
                </Col>
                <Col md={4}>
                    <Row>
                        <Col md={12}>
                            <TextAreaEditorField
                                name="fact_text"
                                label="Добавить факт"
                                value={this.state.fact_text}
                                onChange={this.updateTheFacts}
                                maxLength={500}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Button
                                variant="outline-success"
                                id="url_code"
                                onClick={this.addTheFact}
                                href="#"
                            >
                                <FontAwesomeIcon icon="plus" />
                                {' '}
                                Добавить
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </>
        );
    }

    refresh() {
        this.sendData({
            currentTarget: { id: 'apply_button' },
            target: { id: 'apply_button' },
        });
    }

    game_releases() {
        return (
            <>
                <Col md={6}>
                    <GameReleaseBlock
                        data={this.state.data.releases}
                        game={this.props.match.params.topicId}
                        isClosed={this.state.data.is_closed}
                        onChange={this.handleReleaseChange}
                        onClosedChange={this.handleChange}
                    />
                    {/* <ReleaseBlock
                    data={this.state.data.releases}
                    game={this.props.match.params.topicId}
                    updater={this.handleReleaseChange}
                /> */}
                </Col>
                <Col md={6}>
                    <DownloadButtonsBlock
                        data={this.state.data.urls}
                        game={this.props.match.params.topicId}
                        updater={this.handleUrlsChange}
                    />
                    <RuStorePackage
                        packageName={this.state.data.rustore_package}
                        onChange={this.handleChange}
                    />
                </Col>
            </>
        );
    }

    imgClickHandler(event) {
        const { id } = event.currentTarget;
        const { filename } = event.currentTarget.dataset;

        Dispatcher.emit('PICTURE_ADDED', { id, filename });
    }

    getSelectedDistr() {
        const result = [];
        const distmodels = this.state.data.dist_model.split(',');

        for (let i = 0; i < distmodels.length; i++) {
            const obj = this.state.dist_types.find((x) => x.label === distmodels[i]);

            if (!obj) {
                continue;
            }

            result.push(obj);
        }

        return result;
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        let facts_block = (
            <Col md={8}>
                <Alert variant="warning">
                    Для работы с блоком фактов сохраните
                    игру
                </Alert>
            </Col>
        );

        if (this.state.data.id) {
            facts_block = this.game_facts();
        }

        let releases_block = (
            <Col md={8}>
                <Alert variant="warning">
                    Для работы с блоком релизов сохраните
                    игру
                </Alert>
            </Col>
        );

        if (this.state.data.id) {
            releases_block = this.game_releases();
        }

        return (
            <div>
                <Row className="show-grid">
                    <Col md={12}>
                        <h3>
                            Игра:
                            {' '}
                            <a href={buildGameURL(this.state.data.slug)} target="_blank" rel="noopener noreferrer">
                                {this.state.data.name}
                            </a>
                            {' '}
                            <Link to={`${PROJECT_PREFIX}/games/${this.state.data.id}/stats`}>
                                <FontAwesomeIcon icon="chart-line" />
                            </Link>

                        </h3>
                    </Col>
                </Row>

                <Row className="show-grid">
                    <Col md={8}>
                        <InputField
                            name="name"
                            label="Имя"
                            value={this.state.data.name}
                            onChange={this.titleChange}
                            maxLength={100}
                            required
                            is_not_valid={this.state.not_valid.name || false}
                        />
                        <Row className="show-grid">
                            <Col md={6}>
                                <TextInput
                                    id="slug"
                                    label="Slug"
                                    value={this.state.data.slug}
                                    onChange={this.handleChange}
                                    maxLength={150}
                                    required
                                    error={this.state.not_valid.slug ? 'Поле не валидно' : ''}
                                    rightSectionWidth="auto"
                                    rightSection={(
                                        <Text
                                            p={4}
                                            size="xs"
                                        >
                                            {this.state.data.slug.length}
                                            /
                                            {150}
                                        </Text>
                                    )}
                                />
                            </Col>
                            <Col md={6}>
                                <MapGame
                                    slug={this.state.data.slug}
                                    isDisabled={!this.state.data.id}
                                />
                            </Col>
                        </Row>
                        <MappedGames
                            slug={this.state.data.slug}
                            isDisabled={!this.state.data.id}
                        />
                        <Form.Group>
                            <Form.Label><b>Модель распространения</b></Form.Label>
                            <Select
                                name="dist_model"
                                label="het"
                                isMulti
                                options={this.state.dist_types}
                                value={this.getSelectedDistr()}
                                onChange={this.distSelected}
                            />
                        </Form.Group>
                        <TextAreaField
                            name="site_url"
                            label="Сайт"
                            value={this.state.data.site_url}
                            onChange={this.handleChange}
                        />
                        <Row>
                            <Col md={6}>
                                <TextAreaField
                                    name="name_alt"
                                    label="Альтернативные названия"
                                    value={this.state.data.name_alt}
                                    onChange={this.handleChange}
                                />
                            </Col>
                            <Col md={6}>
                                <TextAreaField
                                    name="name_synonym"
                                    label="Синонимы названия для поиска"
                                    value={this.state.data.name_synonym}
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <TextAreaEditorField
                                    name="seo_text"
                                    label="SEO текст"
                                    value={this.state.data.seo_text}
                                    onChange={this.handleChange}
                                    rows={4}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <TextAreaEditorField
                                    name="descr"
                                    label="Краткое описание"
                                    value={this.state.data.descr}
                                    onChange={this.handleChange}
                                    maxLength={200}
                                    rows={4}
                                    required
                                    is_not_valid={this.state.not_valid.descr || false}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <TextAreaEditorField
                                    name="long_descr"
                                    label="Описание"
                                    value={this.state.data.long_descr}
                                    onChange={this.handleChange}
                                    rows={25}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4}>
                        <Row>
                            <Col md={6}>
                                <InputField
                                    name="views"
                                    label="Просмотры"
                                    value={this.state.data.views}
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </Col>
                            <Col md={6}>
                                <InputField
                                    name="date_release"
                                    label="Дата релиза"
                                    value={this.state.data.date_release}
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputField
                                    name="views_total"
                                    label="Просмотров материалов"
                                    value={this.state.data.views_total}
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </Col>
                            <Col md={6}>
                                <InputField
                                    name="date_release_text"
                                    label="Тип даты релиза"
                                    value={this.state.data.date_release_text}
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <RatingSelectorField
                                    name="rating"
                                    label="Оценка"
                                    value={this.state.data.rating}
                                    onChange={this.handleChange}
                                />
                            </Col>
                            <Col md={6}>
                                <InputField
                                    name="steam_id"
                                    label="ID Steam"
                                    value={this.state.data.steam_id}
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputField
                                    name="date_added"
                                    label="Дата добавления"
                                    value={formatDateTime(this.state.data.date_added)}
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </Col>
                            <Col md={6}>
                                <InputField
                                    name="date_modified"
                                    label="Дата изменения"
                                    value={formatDateTime(this.state.data.date_modified)}
                                    onChange={this.handleChange}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row>
                            <RequirementsBlock
                                onChange={this.handleChange}
                                reqFallback={{ min: this.state.data.sys_req, rec: this.state.data.rec_sys_req }}
                                systemRequirements={this.state.data.system_requirements && JSON.parse(this.state.data.system_requirements)}
                            />
                        </Row>
                        <Row>
                            <Col md={12}>
                                <TextAreaEditorField
                                    name="features"
                                    label="Особенности"
                                    value={this.state.data.features}
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <ImageLeadField
                                    name="picture2"
                                    label="Картинка для шапки"
                                    value={this.state.data.picture2}
                                    onChange={this.handleChange}
                                    restrictions="Разрешение не менее 1000x250. Формат: jpeg."
                                    minSize="1000x250"
                                    required
                                    is_not_valid={this.state.not_valid.picture2 || false}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <ImageLeadField
                                    name="picture"
                                    label="Обложка игры"
                                    value={this.state.data.picture}
                                    onChange={this.handleChange}
                                    restrictions="Разрешение не менее 480x290. Формат: jpeg."
                                    minSize="480x290"
                                    required
                                    is_not_valid={this.state.not_valid.picture || false}
                                />
                            </Col>
                            <Col md={4}>
                                <ImageLeadField
                                    name="icon"
                                    label="Иконка игры"
                                    value={this.state.data.icon}
                                    onChange={this.handleChange}
                                    restrictions="Разрешение не менее 128x128. Формат: jpeg."
                                    minSize="128x128"
                                    is_not_valid={this.state.not_valid.icon || false}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <GalleryBlock
                                    gallery={this.state.data.gallery}
                                    handleGalleryChange={this.handleGalleryChange}
                                    entity_alias="games"
                                    entity_id={this.state.data.id}
                                    imgClickHandler={this.imgClickHandler}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {facts_block}
                </Row>

                <Row>
                    {releases_block}
                </Row>

                <Row>
                    <Col md={6}>
                        <SearchDragList
                            id="similar_games"
                            title="Похожие игры"
                            list={this.state.data.similar_games}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}games/`}
                        />
                    </Col>
                    <Col md={6}>
                        <SearchDragList
                            id="compilations"
                            title="Подборки"
                            list={this.state.data.compilations}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}compilations/`}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={4}>
                        <SearchDragList
                            id="developers"
                            title="Разработчики"
                            list={this.state.data.developers}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}tags/`}
                        />
                    </Col>
                    <Col md={4}>
                        <SearchDragList
                            id="publishers"
                            title="Издатели"
                            list={this.state.data.publishers}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}tags/`}
                        />
                    </Col>
                    <Col md={4}>
                        <SearchDragList
                            id="localizers"
                            title="Локализаторы"
                            list={this.state.data.localizers}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}tags/`}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <SearchDragList
                            id="modes"
                            title="Режим игры"
                            list={this.state.data.modes}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}tags/?type=game_mode`}
                        />
                    </Col>
                    <Col md={6}>
                        <SearchDragList
                            id="genre"
                            title="Жанр"
                            list={this.state.data.genre}
                            onChange={this.handleChange}
                            searchUrl={`${API_DOMAIN}genres/`}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <DateTimeField
                            name="date_published"
                            label="Дата публикации (по Москве)"
                            value={this.state.data.date_published || formatDateTimeForDRF(new Date(getMoscowTime()))}
                            onChange={this.dtHandleChange}
                        />
                    </Col>
                    <Col md={6}>
                        <SearchSelectorField
                            name="tags"
                            label="Теги"
                            value={this.state.data.tags}
                            onChange={this.handleChange}
                            uri={`${API_DOMAIN}tags/?only_tags=true`}
                            isMulti
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <CheckboxField
                            name="is_draft"
                            label="Черновик"
                            value={this.state.data.is_draft}
                            onChange={this.handleChange}
                        />
                        <CheckboxField
                            name="is_published"
                            label="Опубликовано"
                            value={this.state.data.is_published}
                            disabled={this.state.data.is_draft}
                            onChange={this.handleChange}
                        />
                    </Col>
                </Row>
                <ControlPageBlock
                    isClearableCache
                    name={this.state.data.name}
                    onSave={this.sendData}
                    onApply={this.sendData}
                    onCancel={this.goToPreviousPage}
                    onRemove={this.removeData}
                />
            </div>
        );
    }
}
